import React from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-border bg-muted/30" data-testid="site-footer">
      <div className="container mx-auto px-4 sm:px-6 lg:px-12 py-12 grid md:grid-cols-3 gap-10">
        <div>
          <h4 className="font-display text-2xl text-primary mb-2">Pastoral Virreyista 2026</h4>
          <p className="text-sm text-foreground/70 leading-relaxed">
            Familias Virreyistas: ¡El Señor les conceda la paz!
          </p>
          <p className="mt-4 text-xs tracking-[0.2em] uppercase font-semibold text-secondary">
            Pax et Bonum
          </p>
        </div>
        <div>
          <h5 className="text-sm tracking-[0.2em] uppercase font-semibold text-foreground/60 mb-3">
            Rutas formativas
          </h5>
          <ul className="space-y-2 text-sm">
            <li><Link to="/primera-comunion" className="hover:text-primary">Primera Comunión</Link></li>
            <li><Link to="/confirmacion" className="hover:text-primary">Confirmación</Link></li>
            <li><Link to="/centenario" className="hover:text-primary">Centenario Franciscano</Link></li>
            <li><Link to="/login" className="hover:text-primary">Ingresar / Catequistas</Link></li>
          </ul>
        </div>
        <div>
          <h5 className="text-sm tracking-[0.2em] uppercase font-semibold text-foreground/60 mb-3">
            Institución
          </h5>
          <p className="text-sm text-foreground/80 leading-relaxed">
            Colegio Franciscano del Virrey Solís<br />
            Bogotá, Colombia<br />
            Pastoral Educativa
          </p>
        </div>
      </div>
      <div className="border-t border-border py-5 text-center text-xs text-foreground/60 flex items-center justify-center gap-2">
        Hecho con <Heart className="w-3 h-3 text-secondary fill-secondary" /> para la familia franciscana · 2026
      </div>
    </footer>
  );
}
